import request from '@/utils/request'

export function pager(data) {
  return request({
    url: '/api/workAttendanceRest/confirmAttendance',
    method: 'post',
    data,
  })
}

export function doInsertLeave(data) {
  return request({
    url: '/api/workAttendanceRest/insertLeave',
    method: 'post',
    data,
  })
}
